var Backbone, SupportHelpWizardController, SupportOrderListViewTemplate, SupportOrderView, SupportStepActionsView, SupportStepOneActionsTemplate, SupportV2OrderListView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportOrderView = require('./order_list_element_view');

SupportStepActionsView = require('../step_actions_view');

SupportHelpWizardController = require('../../helpWizardController');

SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache');

SupportV2OrderListView = (function(superClass) {
  extend(SupportV2OrderListView, superClass);

  function SupportV2OrderListView() {
    return SupportV2OrderListView.__super__.constructor.apply(this, arguments);
  }

  SupportV2OrderListView.prototype.id = 'orderContent';

  SupportV2OrderListView.prototype.events = {
    "click #select-current-order": "finishChoosingItem",
    "click .orderTableRow td.order-data-cell": "clickingItemsTableRow",
    "click .ordersRowError": "handleErrorLinkClick"
  };

  SupportV2OrderListView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportOrderListViewTemplate;
    this.currentChosenItemId = 0;
    this.currentCheckedRadioBtnSel = 0;
    this.tableId = '#ordersTable';
    this.itemView = SupportOrderView;
    this.currentOrdersFilter = options.currentOrdersFilter;
    this.stepActionsView = new SupportStepActionsView({
      template: SupportStepOneActionsTemplate
    });
    return this.itemsPerRow = 2;
  };

  SupportV2OrderListView.prototype.render = function() {
    var _scrollLoad;
    this.currentOrdersFilter.iterator.resetIterator();
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderStepActions();
    _scrollLoad = (function(_this) {
      return function() {
        var $div;
        $div = $("#ordersTablewrapper", _this.$el);
        if (($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 100)) {
          if (!_this.currentOrdersFilter.iterator.hasNext()) {
            return;
          }
          return _this.renderOrders();
        }
      };
    })(this);
    $("#ordersTablewrapper", this.$el).scroll(_scrollLoad);
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV2OrderListView.prototype.toHash = function() {
    return {
      isV2: true
    };
  };

  SupportV2OrderListView.prototype.renderItems = function(items) {
    var emptyTds, index, itemsTable, itemviewObj, lastRow, noOfEmptyTds, noOfOrderTds, orders, results, singletonItemviewObj;
    if (!((items != null ? items.length : void 0) > 0)) {
      return;
    }
    itemsTable = this.$el.find(this.tableId);
    singletonItemviewObj = new this.itemView;
    emptyTds = $('tr.orderTableRow:last-child td.empty-data-cell', itemsTable);
    noOfEmptyTds = emptyTds.length;
    index = 0;
    while (index < noOfEmptyTds) {
      singletonItemviewObj.replaceEmptyTemplateWithOrderTemplate($(emptyTds[index]), items[index]);
      index++;
    }
    while (index < items.length) {
      orders = items.slice(index, index + this.itemsPerRow);
      itemviewObj = new this.itemView;
      itemviewObj.renderMultipleItems(orders);
      itemsTable.append(itemviewObj.$el);
      index = index + this.itemsPerRow;
    }
    lastRow = $('tr.orderTableRow:last-child', itemsTable);
    noOfOrderTds = $('td.order-data-cell', lastRow).length;
    results = [];
    while (noOfOrderTds > 0 && noOfOrderTds < this.itemsPerRow) {
      lastRow.append(singletonItemviewObj.renderEmptyTemplate());
      results.push(noOfOrderTds++);
    }
    return results;
  };

  SupportV2OrderListView.prototype.finishChoosingItem = function(e) {
    var item;
    if (this.currentChosenItemId != null) {
      item = Groupon.Support.OrdersCollection.findOrderById(this.currentChosenItemId);
      if (item != null) {
        SupportHelpWizardController.stepOne(item);
      }
    }
    return false;
  };

  SupportV2OrderListView.prototype.enableSelectOrder = function() {
    if (this.currentChosenItemId != null) {
      return $("#select-current-order", this.stepActionsView.el).removeAttr('disabled');
    }
  };

  SupportV2OrderListView.prototype.clickingItemsTableRow = function(e) {
    var $oldTd, $td, radioBtn;
    $td = $(e.currentTarget);
    radioBtn = $td.find('input');
    if (this.currentCheckedRadioBtnSel.length > 0) {
      this.currentCheckedRadioBtnSel.prop('checked', false);
      $oldTd = this.currentCheckedRadioBtnSel.closest('td.order-data-cell');
      $oldTd.removeClass('selected');
    }
    this.currentCheckedRadioBtnSel = radioBtn;
    radioBtn.prop('checked', true);
    $td.addClass('selected');
    this.currentChosenItemId = $td.attr('key');
    this.enableSelectOrder();
    return true;
  };

  SupportV2OrderListView.prototype.handleErrorLinkClick = function() {
    this.currentOrdersFilter.iterator.resetState();
    return this.renderOrders();
  };

  SupportV2OrderListView.prototype.renderOrders = function() {
    var errCb, successCb;
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    this.removeOrdersFetchError();
    this.renderSpinner();
    successCb = (function(_this) {
      return function(orders) {
        _this.removeSpinner();
        if ((orders != null ? orders.length : void 0) > 0) {
          _this.renderItems(orders);
          return _this.checkIfMinimumOrdersAreShown();
        } else {
          return _this.renderOrders();
        }
      };
    })(this);
    errCb = (function(_this) {
      return function() {
        _this.removeSpinner();
        return _this.renderOrdersFetchError();
      };
    })(this);
    return this.currentOrdersFilter.iterator.next(successCb, errCb);
  };

  SupportV2OrderListView.prototype.checkIfMinimumOrdersAreShown = function() {
    if (!this.currentOrdersFilter.iterator.hasNext()) {
      return;
    }
    if (this.currentOrdersFilter.iterator.getNumberOfOrdersFetched() < this.currentOrdersFilter.iterator.getNumberOfItemPerPage()) {
      return this.renderOrders();
    }
  };

  SupportV2OrderListView.prototype.renderOrdersFetchError = function() {
    var ordersTable;
    this.removeOrdersFetchError();
    ordersTable = $(this.el).find(this.tableId);
    return ordersTable.append(this.errorHtml());
  };

  SupportV2OrderListView.prototype.errorHtml = function() {
    var $ordersRowError;
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', this.$el).clone();
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError');
    return $ordersRowError;
  };

  SupportV2OrderListView.prototype.removeOrdersFetchError = function() {
    return $('.ordersRowError', this.$el).remove();
  };

  SupportV2OrderListView.prototype.renderSpinner = function() {
    var ordersTable;
    this.removeSpinner();
    ordersTable = this.$el.find(this.tableId);
    return ordersTable.append(this.spinnerHtml());
  };

  SupportV2OrderListView.prototype.spinnerHtml = function() {
    var $div, $ordersRowSpinner;
    $div = $("<div></div>");
    showLoading($div, "50px");
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', this.$el).clone();
    $('.content', $ordersRowSpinner).html($div.html());
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner');
    return $ordersRowSpinner;
  };

  SupportV2OrderListView.prototype.removeSpinner = function() {
    return $('.ordersRowSpinner', this.$el).remove();
  };

  SupportV2OrderListView.prototype.renderStepActions = function() {
    this.stepActionsView.render();
    return this.$el.append(this.stepActionsView.el);
  };

  SupportV2OrderListView.prototype.removeView = function() {
    this.remove();
    this.$el.empty();
    this.stepActionsView.remove();
    return this.stepActionsView.$el.empty();
  };

  return SupportV2OrderListView;

})(Backbone.View);

module.exports = SupportV2OrderListView;

//# sourceMappingURL=data:application/json;base64,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
